import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { GalaxyAvatarModule } from '@vendasta/galaxy/avatar';

import { ChatBubbleComponent } from './chat-bubble/chat-bubble.component';
export { ChatBubbleComponent };

import { ChatDividerTextComponent } from './chat-divider-text/chat-divider-text.component';
export { ChatDividerTextComponent };

import { ChatEventComponent } from './chat-event/chat-event.component';
export { ChatEventComponent };

import { ChatContainerComponent } from './chat-container/chat-container.component';
export { ChatContainerComponent };

import { ChatMessageGroupComponent } from './chat-message-group/chat-message-group.component';
export { ChatMessageGroupComponent };

import { ChatMessageComponent } from './chat-message/chat-message.component';
export { ChatMessageComponent };

import { ChatMessageStatus } from './chat-message/chat-message.component';
export { ChatMessageStatus };

import { AdditionalMetadataDirective } from './directives/additional-metadata';

export const MODULE_IMPORTS = [
  CommonModule,
  MatTooltipModule,
  CdkScrollableModule,
  GalaxyAvatarModule,
  ChatMessageGroupComponent,
  ChatMessageComponent,
  ChatBubbleComponent,
  ChatDividerTextComponent,
  ChatEventComponent,
  ChatContainerComponent,
  AdditionalMetadataDirective,
  MatButtonModule,
  MatIconModule,
];

export const MODULE_EXPORTS = [
  ChatBubbleComponent,
  ChatDividerTextComponent,
  ChatEventComponent,
  ChatContainerComponent,
  ChatMessageGroupComponent,
  ChatMessageComponent,
  AdditionalMetadataDirective,
];

@NgModule({
  imports: MODULE_IMPORTS,
  exports: MODULE_EXPORTS,
})
export class GalaxyChatModule {}
